module.exports = __webpack_public_path__ + "img/Weapon_35.cd088b40.png";